export default __webpack_public_path__ + "static/1-b49c2cc82eaea3688c5f2ee99e79894d.jpeg";